const RAW_BASE_PATH =
  (process.env.REACT_APP_ADMIN_BASENAME ??
    process.env.REACT_APP_ADMIN_BASE_PATH ??
    process.env.PUBLIC_URL ??
    "").trim();

function normalizeBasePath(raw: string): string {
  if (!raw || raw === "/" || raw === ".") {
    return "";
  }

  let normalized = raw;
  if (!normalized.startsWith("/")) {
    normalized = `/${normalized}`;
  }

  normalized = normalized.replace(/\/+$/, "");
  return normalized === "/" ? "" : normalized;
}

const ADMIN_BASE_PATH = normalizeBasePath(RAW_BASE_PATH);

export function getAdminBasePath(): string {
  return ADMIN_BASE_PATH;
}

export function getRouterBaseName(): string | undefined {
  return ADMIN_BASE_PATH || undefined;
}

export function buildAdminPath(path: string): string {
  const normalizedPath = path ? (path.startsWith("/") ? path : `/${path}`) : "/";
  if (!ADMIN_BASE_PATH) {
    return normalizedPath;
  }
  return `${ADMIN_BASE_PATH}${normalizedPath === "/" ? "" : normalizedPath}`;
}
